<template>
    <div class="book-parts-changes-toolbar">
        <div class="book-parts-changes-toolbar__tabs">
            <button
                v-for="tab in Object.keys(tabs)"
                :key="tab"
                v-t="`editor.toolbar.${tab}`"
                :class="{ 'is-selected': selectedTab === tab }"
                @click="selectTab(tab)"
            />
        </div>
        <div class="book-parts-changes-toolbar__tabs-content">
            <div
                v-for="(component, name) in tabs"
                :key="name"
                :class="{ 'is-selected': selectedTab === name }"
            >
                <component :is="component" :languages="languages" :providers="providers" />
            </div>
        </div>
    </div>
</template>

<script>
import DictionaryForm from '../DictionaryForm/DictionaryForm';
import SpecialSymbols from '../SpecialSymbols/SpecialSymbols';
import Phonemes from '../Phonemes/Phonemes';

export default {
    name: 'BookPartsChangesToolbar',
    data() {
        return {
            tabs: {
                dictionary: DictionaryForm,
                specialSymbols: SpecialSymbols,
                phonemes: Phonemes
            },
            selectedTab: undefined,
            providers: [],
            languages: []
        };
    },
    mounted() {
        this.selectTab(Object.keys(this.tabs)[0]);
    },
    async created() {
        this.loading = true;
        try {
            await Promise.all([this.fetchLanguages(), this.fetchProviders()]);
        } catch (err) {
            console.log(err);
        } finally {
            this.loading = false;
        }
    },
    methods: {
        async fetchProviders() {
            const { results } = await this.$http.get('/api/v1/admin/speech_settings/providers/');
            this.providers = results;
        },
        async fetchLanguages() {
            const { results } = await this.$http.get('/api/v1/admin/speech_settings/languages/');
            this.languages = results;
        },
        selectTab(name) {
            this.selectedTab = name;
        }
    }
};
</script>

<style lang="scss" src="./BookPartsChangesToolbar.scss"></style>
